"use strict";

exports.__esModule = true;
exports.MetricTableWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChartCard = require("../common/ChartCard");
var _reactIntl = require("react-intl");
var _DataTable = require("../DataTable");
var _MetricTableElement = require("./MetricTableElement");
var _MetricTableFields = require("./MetricTableFields");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MetricTableWidget = exports.MetricTableWidget = {
  name: "MetricTable",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MetricTableWidget.label",
    defaultMessage: "Metric Table"
  }),
  icon: "th-list",
  group: _widgetGroups.METRIC_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "MetricTable",
      props: Object.assign({
        width: 512,
        height: 512,
        filters: [],
        configuration: {
          enablePagination: true,
          overFetchAll: true
        },
        dataRange: "",
        pivotByTime: false,
        showAverageColumn: false,
        showTotalColumn: false,
        showChangeColumn: false,
        showHeatMap: false,
        showTrendColumn: false,
        showTargets: false,
        excludeZeroValues: false
      }, props, {
        pageSizes: [25, 50, 100, 250]
      }),
      children: [{
        type: "AdvancedDataTableColumn",
        props: {
          hideTypeSelector: true,
          canFilter: false,
          section: "metrics",
          id: "utilization",
          name: "utilization",
          label: "Utilization",
          sanitizedFieldName: "Utilization",
          type: "fractionalPercent",
          sortIndex: "utilization",
          x: 0,
          y: 0,
          height: 64,
          width: 256
        },
        children: []
      }]
    };
  },
  showInPalette: true,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "onClickAction"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 320,
      min: 32,
      max: 1024
    },
    height: {
      "default": 320,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: (0, _ChartCard.withChartCard)(_MetricTableElement.MetricTableElement),
    Fields: _MetricTableFields.MetricTableFields,
    Thumbnail: _DataTable.DataTableThumbnail
  }
};